import r01 from "@/assets/reviews/r01.jpg?format=webp&quality=72&w=96";
import r02 from "@/assets/reviews/r02.jpg?format=webp&quality=72&w=96";
import r03 from "@/assets/reviews/r03.jpg?format=webp&quality=72&w=96";
import r04 from "@/assets/reviews/r04.jpg?format=webp&quality=72&w=96";
import r05 from "@/assets/reviews/r05.jpg?format=webp&quality=72&w=96";
import r06 from "@/assets/reviews/r06.jpg?format=webp&quality=72&w=96";
import r07 from "@/assets/reviews/r07.jpg?format=webp&quality=72&w=96";
import r08 from "@/assets/reviews/r08.jpg?format=webp&quality=72&w=96";
import r09 from "@/assets/reviews/r09.jpg?format=webp&quality=72&w=96";
import r10 from "@/assets/reviews/r10.jpg?format=webp&quality=72&w=96";
import r11 from "@/assets/reviews/r11.jpg?format=webp&quality=72&w=96";
import r12 from "@/assets/reviews/r12.jpg?format=webp&quality=72&w=96";
import r13 from "@/assets/reviews/r13.jpg?format=webp&quality=72&w=96";
import r14 from "@/assets/reviews/r14.jpg?format=webp&quality=72&w=96";
import r15 from "@/assets/reviews/r15.jpg?format=webp&quality=72&w=96";
import r16 from "@/assets/reviews/r16.jpg?format=webp&quality=72&w=96";
import r17 from "@/assets/reviews/r17.jpg?format=webp&quality=72&w=96";
import r18 from "@/assets/reviews/r18.jpg?format=webp&quality=72&w=96";
import r19 from "@/assets/reviews/r19.jpg?format=webp&quality=72&w=96";
import r20 from "@/assets/reviews/r20.jpg?format=webp&quality=72&w=96";

export type ReviewCategory =
  | "executive"
  | "faith"
  | "educator"
  | "founder"
  | "civic";

export type Review = {
  name: string;
  role: string;
  location: string;
  quote: string;
  rating: 5;
  image: string;
  category: ReviewCategory;
  featured?: boolean;
};

export const REVIEW_CATEGORIES: { value: ReviewCategory | "all"; label: string }[] = [
  { value: "all", label: "All Reviews" },
  { value: "executive", label: "Executives & CEOs" },
  { value: "faith", label: "Faith Leaders" },
  { value: "educator", label: "Educators" },
  { value: "founder", label: "Founders" },
  { value: "civic", label: "Civic & Community" },
];

export const REVIEWS: Review[] = [
  {
    name: "Elena Ramírez",
    role: "Executive Coach · Latina Leaders Collective",
    location: "San Antonio, TX",
    quote:
      "Dr. Sully didn't hand me a script — he handed me a framework. MAKECHANGE rebuilt how I lead my team, my marriage, and my calendar. Six months in, our revenue doubled and I'm finally sleeping.",
    rating: 5,
    image: r01,
    category: "executive",
    featured: true,
  },
  {
    name: "Pastor Marcus Bell",
    role: "Lead Pastor · New Foundation Church",
    location: "Houston, TX",
    quote:
      "I've sat under a lot of teachers. Sully is the first one who told the truth about the unhealed leader tax — and gave me the AI tools to scale without burning my staff out.",
    rating: 5,
    image: r02,
    category: "faith",
    featured: true,
  },
  {
    name: "Daniela Cruz",
    role: "Founder · Puentes Nonprofit",
    location: "San Antonio, TX",
    quote:
      "Faith-informed and business-driven is not a tagline with him — it's how he coaches. We landed our first six-figure grant after one Make Change Scan.",
    rating: 5,
    image: r03,
    category: "founder",
  },
  {
    name: "Brett Hollis",
    role: "CEO · NorthRail Logistics",
    location: "Austin, TX",
    quote:
      "I came in skeptical of the 'faith' part. I left with a P&L overhaul, a real exec rhythm, and an apology owed to my COO. Dr. Sully tells the truth — kindly.",
    rating: 5,
    image: r04,
    category: "executive",
    featured: true,
  },
  {
    name: "Imani Walker",
    role: "Founder · Crown Beauty Co.",
    location: "Atlanta, GA",
    quote:
      "He helped me see my expertise as a fundable program, not a hustle. The pillar work alone changed how I sell.",
    rating: 5,
    image: r05,
    category: "founder",
  },
  {
    name: "Dr. Mei-Lin Chen",
    role: "Principal · Coronado Academy",
    location: "San Antonio, TX",
    quote:
      "Sully's coaching gave my admin team a shared language. We dropped staff turnover by 38% in one school year.",
    rating: 5,
    image: r06,
    category: "educator",
  },
  {
    name: "Adebayo Okonkwo",
    role: "CFO · Lagos-Houston Capital",
    location: "Lagos, Nigeria",
    quote:
      "Borrowed power runs out — that line cost me sleep, then rebuilt my board strategy. He coaches at a global standard.",
    rating: 5,
    image: r07,
    category: "executive",
  },
  {
    name: "Dr. Priya Sharma",
    role: "Associate Professor · UT Health",
    location: "San Antonio, TX",
    quote:
      "Trauma-informed and analytical — a rare combination. He moved me from imposter syndrome to keynote stages in one cohort.",
    rating: 5,
    image: r08,
    category: "educator",
  },
  {
    name: "Reynaldo 'Rey' Galván",
    role: "Owner · Galván Construction Group",
    location: "Laredo, TX",
    quote:
      "I'm a third-generation builder. Sully showed me how to build leaders the way I build foundations. Mijo, this man is the real deal.",
    rating: 5,
    image: r09,
    category: "founder",
  },
  {
    name: "Bishop Yvonne Carter",
    role: "Presiding Bishop · Living Word Network",
    location: "Memphis, TN",
    quote:
      "I've shared pulpits with the best of them. Dr. Sully carries an honest kingdom voice — and the academic chops to back it. My leadership council reads him quarterly.",
    rating: 5,
    image: r10,
    category: "faith",
    featured: true,
  },
  {
    name: "MSgt. Joseph Dela Cruz (Ret.)",
    role: "Veteran Transition Coach",
    location: "San Antonio, TX",
    quote:
      "Twenty-two years in uniform. Sully's MAKECHANGE Framework is the cleanest leadership doctrine I've seen since the Marine Corps manuals.",
    rating: 5,
    image: r11,
    category: "civic",
  },
  {
    name: "Camila Santos",
    role: "Keynote Speaker · Bilingual Business Bureau",
    location: "Miami, FL",
    quote:
      "He doesn't sell hype. He sells repeatable systems. My speaking fee tripled and I finally stopped negotiating against myself.",
    rating: 5,
    image: r12,
    category: "founder",
  },
  {
    name: "Omar Haddad",
    role: "City Council Member",
    location: "Dearborn, MI",
    quote:
      "I needed someone who could speak to faith, civics, and AI in one breath. Dr. Sully is that someone.",
    rating: 5,
    image: r13,
    category: "civic",
  },
  {
    name: "Sora Park",
    role: "AI Product Lead · Northstar Labs",
    location: "Seoul, South Korea",
    quote:
      "Most coaches don't understand agents and automation. Sully does. He helped me ship our AI roadmap with ethical guardrails my CEO actually trusts.",
    rating: 5,
    image: r14,
    category: "executive",
    featured: true,
  },
  {
    name: "Dr. Margaret Whitlock",
    role: "Superintendent · Hill Country ISD",
    location: "Boerne, TX",
    quote:
      "I've hired four coaches over my career. Dr. Sully is the only one whose framework outlasted the engagement. My principals still quote him.",
    rating: 5,
    image: r15,
    category: "educator",
  },
  {
    name: "Devonte 'Dev' Marshall",
    role: "Founder · BlackBoxx Studios",
    location: "Brooklyn, NY",
    quote:
      "Sully gets the culture and the cap table. He coached me through my first raise and called me out when I was performing instead of building.",
    rating: 5,
    image: r16,
    category: "founder",
  },
  {
    name: "Ayanna Beaumont",
    role: "Hospital Chaplain · Methodist Health",
    location: "San Antonio, TX",
    quote:
      "Healing before scale changed my ministry. I bring his framework into every grief room I walk into.",
    rating: 5,
    image: r17,
    category: "faith",
  },
  {
    name: "Hector Salazar",
    role: "Owner · Salazar Auto Group",
    location: "San Antonio, TX",
    quote:
      "I run three shops on the South Side. Dr. Sully turned my chaos into clarity. The clarity printed money.",
    rating: 5,
    image: r18,
    category: "founder",
  },
  {
    name: "Akosua Mensah",
    role: "Founder · Accra Women in Tech",
    location: "Accra, Ghana",
    quote:
      "Coaching across time zones is hard. Coaching across cultures is harder. Dr. Sully made both look effortless — and our cohort raised $1.2M.",
    rating: 5,
    image: r19,
    category: "founder",
    featured: true,
  },
  {
    name: "Tate Begay",
    role: "Tribal Council Member · Diné Nation",
    location: "Window Rock, AZ",
    quote:
      "He listened first. Then he coached. Then he built. That is the order our elders respect — and the order leaders should follow.",
    rating: 5,
    image: r20,
    category: "civic",
  },
];

export const FEATURED_REVIEWS = REVIEWS.filter((r) => r.featured);
